import React from 'react';
import PropTypes from 'prop-types';
import QuestionText from './QuestionText';
import MultiSelectBoxesOptions from './MultiSelectBoxesOptions';

const MultiSelectBoxesQuestion = ({question, item, data, answerOptions, handleAnswer}) => {
  const selectedValues = item in data ? data[item] : [];
  return (
    <React.Fragment>
      <QuestionText>
        {question}
      </QuestionText>
      <MultiSelectBoxesOptions
        item={item}
        options={answerOptions}
        handleAnswer={handleAnswer}
        selectedValues={selectedValues}
      />
    </React.Fragment>
  );
};

MultiSelectBoxesQuestion.propTypes = {
  question: PropTypes.string.isRequired,
  item: PropTypes.string.isRequired,
  data: PropTypes.object,
  answerOptions: PropTypes.array.isRequired,
  handleAnswer: PropTypes.func.isRequired,
};

export default MultiSelectBoxesQuestion;
